module.exports = __webpack_public_path__ + "img/placeholder-footer.baf52c6e.png";